// Roadmap.js
// Roadmap.js
import React from 'react';
import { Box, Typography } from '@mui/material';

export default function Roadmap() {
  return (
    <Box className="roadmap-container">
      {/* <Typography
        variant="h4"
        align="center"
        gutterBottom
        className="title-glow"
      >
        Roadmap
      </Typography> */}
      <Box className="roadmap-section">
        <Box className="roadmap-line">
          <Box className="roadmap-phase">
            <Typography variant="h6" className="title-glow">
              Phase 1 - Genesis
            </Typography>
            <ul>
              <li className="description-text">Launch Website & Whitepaper</li>
              <li className="description-text">Establish Core Community</li>
              <li className="description-text">Initial Exchange Listings</li>
            </ul>
          </Box>
          <Box className="roadmap-connector" />
          <Box className="roadmap-phase">
            <Typography variant="h6" className="title-glow">
              Phase 2 - Expansion
            </Typography>
            <ul>
              <li className="description-text">Develop innovative AI projects inspired by meme culture</li>
              <li className="description-text">Form strategic partnerships</li>
              <li className="description-text">Secure listings on CoinGecko & CMC</li>
              <li className="description-text">Broaden the reach and influence of The Key Maker</li>
              <li className="description-text">Grow community with groundbreaking initiatives</li>
            </ul>
          </Box>
          <Box className="roadmap-connector" />
          <Box className="roadmap-phase">
            <Typography variant="h6" className="title-glow">
              Phase 3 - Innovation
            </Typography>
            <ul>
              <li className="description-text">Development Of Advanced AI Meme Projects</li>
              <li className="description-text">Secure Major CEX Listings</li>
              <li className="description-text">Execute Global Marketing Campaign</li>
            </ul>
          </Box>
          <Box className="roadmap-connector" />
          <Box className="roadmap-phase">
            <Typography variant="h6" className="title-glow">
              Phase 4 - Evolution
            </Typography>
            <ul>
              <li className="description-text">Integrate Real-World Meme/AI Solutions</li>
              <li className="description-text">Drive Community-Led Projects</li>
              <li className="description-text">Incubate Next-Gen AI Initiatives</li>
            </ul>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
